import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { loginSuccess, logout, restoreSession, setLoading } from '../slices/authSlice';
import authService from '../services/authService';

export const useAuth = () => {
    const dispatch = useDispatch();
    const { user, token, isAuthenticated, isLoading } = useSelector((state) => state.auth);

    // Restore session on mount
    useEffect(() => {
        const restoreAuth = async () => {
            try {
                const storedToken = localStorage.getItem('token');  // Renamed to avoid confusion
                const storedUser = localStorage.getItem('user');     // Renamed to avoid confusion
                
                if (storedToken && storedUser) {
                    dispatch(restoreSession());
                } else {
                    dispatch(setLoading(false));
                }
            } catch (error) {
                console.error('Error restoring session:', error);
                dispatch(setLoading(false));
            }
        };
        
        restoreAuth();
    }, [dispatch]);

    const login = async (credentials) => {
        try {
            dispatch(setLoading(true));
            const response = await authService.login(credentials);
            dispatch(loginSuccess({ 
                user: response.user, 
                token: response.token, 
                refreshToken: response.refreshToken 
            }));
            return { success: true };
        } catch (error) {
            console.error('Login error:', error);
            dispatch(setLoading(false));
            return { success: false, error: error.message };
        }
    };

    const logoutUser = () => {
        authService.logout();
        dispatch(logout());
    };

    return { user, token, isAuthenticated, isLoading, login, logout: logoutUser };
};